import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { EnergyGroupModel } from '../../models/energyGroup.model';
import { EnergyGroupService } from '../../services/energy-group.service';
import { DependentModel } from '../../models/dependent.model';
import { ChartComponent } from 'angular2-chartjs';

@Component({
  selector: 'app-dash-graphic',
  templateUrl: './dash-graphic.component.html',
  styleUrls: ['./dash-graphic.component.less']
})

export class DashGraphicComponent implements OnInit {

  @Input() dependentId: string;
  @Input() companyId: string;
  @ViewChild(ChartComponent) chart: ChartComponent;

  [x: string]: any;
  dependents: DependentModel[] = new Array<DependentModel>();
  type = 'bar';
  daysOfResume = 30;
  noneValue = 0;
  datasetGeralPosition = 0;
  datasetDependentPosition = 1;

  data = {
    labels: [
      '0',
      '1',
      '2',
      '3',
      '4',
      '5',
      '6',
      '7'
    ],
    fakeLabels: [
      'Indefinido', 'Doces', 'Cereais e ovos', 'Laticinios', 'Sucos naturais', 'Frutas', 'Carboidratos', 'Frituras e industrializados'
    ],
    datasets: [
      {
        label: 'Consumo Geral',
        data: [],
        backgroundColor: '#CCC'
      },
      {
        label: 'Consumo Dependente',
        data: [],
        backgroundColor: '#32008E'
      }
    ],
  };

  options: {

    scales: {
      xAxes: [{
          stacked: true
      }],
      yAxes: [{
          stacked: true
      }]
  }

  };

  constructor(private energyGroupService: EnergyGroupService) {
  }

  private pushValueToGraph(datasetPosition: number, value: number) {
    this.data.datasets[datasetPosition].data.push(value);
  }

  private SetGeralValuesOnChart() {
    this.energyGroupService.getAll(this.companyId, this.daysOfResume)
      .then((_energyGroups: EnergyGroupModel[]) => {
        if (_energyGroups.length > 0) {
          const totalSales = this.getTotalSales(_energyGroups);

          this.setPercentToEnergyGroups(_energyGroups, totalSales);

          this.data.labels.forEach(label => {
            const index = this.data.labels.indexOf(label);
            const energyGroup = _energyGroups.find(group => group.GrupoLabel === this.data.fakeLabels[index]);

            if (energyGroup !== null && energyGroup !== undefined) {
              this.pushValueToGraph(this.datasetGeralPosition, energyGroup.percent);
            } else {
              this.pushValueToGraph(this.datasetGeralPosition, this.noneValue);
            }

          });
          this.chart.chart.update();
        }
      });
  }

  private getTotalSales(energyGroups: Array<EnergyGroupModel>) {
    let total = 0;
    energyGroups.forEach(energyGroup => {
      total += energyGroup.Quantidade;
    });

    return total;
  }

  private getPercent(value: number, totalSales: number) {
    return Number(((value * 100) / totalSales).toFixed(2));
  }

  private setPercentToEnergyGroups(energyGroups: Array<EnergyGroupModel>, totalSales: number) {
    energyGroups.forEach(energyGroup => {
      energyGroup.percent = this.getPercent(energyGroup.Quantidade, totalSales);
    });

    return energyGroups;
  }

  private SetDependentValuesOnChart() {
    this.energyGroupService.get(this.dependentId, this.daysOfResume)
      .then((_energyGroups: EnergyGroupModel[]) => {
        if (_energyGroups.length > 0) {
          const totalSales = this.getTotalSales(_energyGroups);

          this.setPercentToEnergyGroups(_energyGroups, totalSales);

          this.data.labels.forEach(label => {
            const index = this.data.labels.indexOf(label);
            const energyGroup = _energyGroups.find(group => group.GrupoLabel === this.data.fakeLabels[index]);

            if (energyGroup !== null && energyGroup !== undefined) {
              this.pushValueToGraph(this.datasetDependentPosition, energyGroup.percent);
            } else {
              this.pushValueToGraph(this.datasetDependentPosition, this.noneValue);
            }

          });
          this.chart.chart.update();
        }
      });
  }

  ngOnInit() {
    this.SetGeralValuesOnChart(); // TODO: Uma requisição do geral para todos os dependentes
    this.SetDependentValuesOnChart();



    // this.data.labels.push('GroupA');

    // this.data.datasets[0].data.push(10);

    // this.data.labels.push('GroupB');

    // this.data.datasets[1].data.push(15);
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/dash-graphic/dash-graphic.component.ts